const translationKeys = {
  components_reorderable_account_cell_show_account_button:
    'components_reorderable_account_cell_show_account_button',
  components_reorderable_account_cell_hide_account_button:
    'components_reorderable_account_cell_hide_account_button',
  components_transaction_cell_reserved_status:
    'components_transaction_cell_reserved_status',
  components_skeleton_loading_text: 'components_skeleton_loading_text',
  components_api_error_card_try_again_button:
    'components_api_error_card_try_again_button',
  components_rating_aria_label_text: 'components_rating_aria_label_text',
  components_risk_score_low_risk_score: 'components_risk_score_low_risk_score',
  components_risk_score_unknown_risk_score:
    'components_risk_score_unknown_risk_score',
  components_risk_score_medium_risk_score:
    'components_risk_score_medium_risk_score',
  components_risk_score_high_risk_score:
    'components_risk_score_high_risk_score',
  components_social_responsibility_index_unknown:
    'components_social_responsibility_index_unknown',
  components_social_responsibility_index_green:
    'components_social_responsibility_index_green',
  components_social_responsibility_index_red:
    'components_social_responsibility_index_red',
  components_social_responsibility_index_yellow:
    'components_social_responsibility_index_yellow',
  components_rating_unknown: 'components_rating_unknown',
  components_fund_sector_breakdown_materialer:
    'components_fund_sector_breakdown_materialer',
  components_fund_sector_breakdown_kommunikasjonstjenester:
    'components_fund_sector_breakdown_kommunikasjonstjenester',
  components_fund_sector_breakdown_syklisk_konsum:
    'components_fund_sector_breakdown_syklisk_konsum',
  components_fund_sector_breakdown_stabilt_konsum:
    'components_fund_sector_breakdown_stabilt_konsum',
  components_fund_sector_breakdown_helse:
    'components_fund_sector_breakdown_helse',
  components_fund_sector_breakdown_industri:
    'components_fund_sector_breakdown_industri',
  components_fund_sector_breakdown_eiendom:
    'components_fund_sector_breakdown_eiendom',
  components_fund_sector_breakdown_teknologi:
    'components_fund_sector_breakdown_teknologi',
  components_fund_sector_breakdown_finans:
    'components_fund_sector_breakdown_finans',
  components_fund_sector_breakdown_forsying:
    'components_fund_sector_breakdown_forsying',
  components_fund_sector_breakdown_annet:
    'components_fund_sector_breakdown_annet',
  components_fund_sector_breakdown_udefinert:
    'components_fund_sector_breakdown_udefinert',
  components_fund_morningstar_geography_type_usa:
    'components_fund_morningstar_geography_type_usa',
  components_fund_morningstar_geography_type_canada:
    'components_fund_morningstar_geography_type_canada',
  components_fund_morningstar_geography_type_latin_amerika:
    'components_fund_morningstar_geography_type_latin_amerika',
  components_fund_morningstar_geography_type_storbritannia:
    'components_fund_morningstar_geography_type_storbritannia',
  components_fund_morningstar_geography_type_euro_sonen:
    'components_fund_morningstar_geography_type_euro_sonen',
  components_fund_morningstar_geography_type_europa_ex_euro:
    'components_fund_morningstar_geography_type_europa_ex_euro',
  components_fund_morningstar_geography_type_europa_fremvoksende:
    'components_fund_morningstar_geography_type_europa_fremvoksende',
  components_fund_morningstar_geography_type_afrika:
    'components_fund_morningstar_geography_type_afrika',
  components_fund_morningstar_geography_type_midtosten:
    'components_fund_morningstar_geography_type_midtosten',
  components_fund_morningstar_geography_type_japan:
    'components_fund_morningstar_geography_type_japan',
  components_fund_morningstar_geography_type_australia:
    'components_fund_morningstar_geography_type_australia',
  components_fund_morningstar_geography_type_asia_utviklet:
    'components_fund_morningstar_geography_type_asia_utviklet',
  components_fund_morningstar_geography_type_asia_fremvoksende:
    'components_fund_morningstar_geography_type_asia_fremvoksende',
  components_fund_morningstar_geography_type_fremvoksende_markeder:
    'components_fund_morningstar_geography_type_fremvoksende_markeder',
  components_fund_morningstar_geography_type_utviklede_markeder:
    'components_fund_morningstar_geography_type_utviklede_markeder',
  components_fund_morningstar_geography_type_annet:
    'components_fund_morningstar_geography_type_annet',
  components_fund_morningstar_geography_type_udefinert:
    'components_fund_morningstar_geography_type_udefinert',
  components_down_weighting_chart_aria_label_off:
    'components_down_weighting_chart_aria_label_off',
  components_down_weighting_chart_aria_label:
    'components_down_weighting_chart_aria_label',
  components_down_weighting_chart_year: 'components_down_weighting_chart_year',
  components_fund_sector_breakdown_energi:
    'components_fund_sector_breakdown_energi',
  components_empty_state_image_alt_text:
    'components_empty_state_image_alt_text',
  components_fund_properties_title: 'components_fund_properties_title',
  components_fund_properties_risk_score:
    'components_fund_properties_risk_score',
  components_fund_properties_morningstar_rating:
    'components_fund_properties_morningstar_rating',
  components_fund_properties_minimum_subscription_amount:
    'components_fund_properties_minimum_subscription_amount',
  components_fund_properties_social_responsibility_index:
    'components_fund_properties_social_responsibility_index',
  components_fund_properties_annual_fee:
    'components_fund_properties_annual_fee',
  components_fund_properties_nav_price: 'components_fund_properties_nav_price',
  components_fund_properties_unknown_value:
    'components_fund_properties_unknown_value',
  components_fund_description_title: 'components_fund_description_title',
  components_fund_description_read_more_button_text:
    'components_fund_description_read_more_button_text',
  components_fund_description_read_more_button_title:
    'components_fund_description_read_more_button_title',
  components_fund_description_fallback_text:
    'components_fund_description_fallback_text',
  components_image_alt_mortgage: 'components_image_alt_mortgage',
  components_image_alt_fly: 'components_image_alt_fly',
  components_image_alt_lost_connection: 'components_image_alt_lost_connection',
  components_fund_allocation_title: 'components_fund_allocation_title',
  components_fund_allocation_allocation_bar_interest_label:
    'components_fund_allocation_allocation_bar_interest_label',
  components_fund_allocation_allocation_bar_stocks_label:
    'components_fund_allocation_allocation_bar_stocks_label',
  components_fund_allocation_fallback_text:
    'components_fund_allocation_fallback_text',
  components_fund_portfolio_title: 'components_fund_portfolio_title',
  components_fund_portfolio_tab_title_investments:
    'components_fund_portfolio_tab_title_investments',
  components_fund_portfolio_tab_title_regions:
    'components_fund_portfolio_tab_title_regions',
  components_fund_portfolio_tab_title_sectors:
    'components_fund_portfolio_tab_title_sectors',
  components_fund_portfolio_fallback_text:
    'components_fund_portfolio_fallback_text',
  components_image_alt_fund_order: 'components_image_alt_fund_order',
  components_image_alt_savings_goal: 'components_image_alt_savings_goal',
  components_image_alt_money_bag: 'components_image_alt_money_bag',
  components_image_alt_funds_market: 'components_image_alt_funds_market',
  components_historic_price_chart_filter_button_this_year:
    'components_historic_price_chart_filter_button_this_year',
  components_historic_price_chart_filter_button_one_month:
    'components_historic_price_chart_filter_button_one_month',
  components_historic_price_chart_filter_button_six_months:
    'components_historic_price_chart_filter_button_six_months',
  components_historic_price_chart_filter_button_one_year:
    'components_historic_price_chart_filter_button_one_year',
  components_historic_price_chart_filter_button_three_years:
    'components_historic_price_chart_filter_button_three_years',
  components_historic_price_chart_filter_button_five_years:
    'components_historic_price_chart_filter_button_five_years',
  components_fund_properties_performance_fee:
    'components_fund_properties_performance_fee',
  components_fund_properties_performance_fee_description:
    'components_fund_properties_performance_fee_description',
  components_fund_properties_performance_fee_description_link:
    'components_fund_properties_performance_fee_description_link',
  components_image_alt_empty_mailbox: 'components_image_alt_empty_mailbox',
  components_image_alt_pointing_person: 'components_image_alt_pointing_person',
  components_breadcrumb_item_home: 'components_breadcrumb_item_home',
  components_breadcrumb_item_savings: 'components_breadcrumb_item_savings',
  components_fund_development_ytd: 'components_fund_development_ytd',
  components_fund_development_1_month: 'components_fund_development_1_month',
  components_fund_development_6_months: 'components_fund_development_6_months',
  components_fund_development_1_year: 'components_fund_development_1_year',
  components_fund_development_3_years: 'components_fund_development_3_years',
  components_fund_development_5_years: 'components_fund_development_5_years',
  components_fund_development_since_launch:
    'components_fund_development_since_launch',
  components_fund_launch_date: 'components_fund_launch_date',
  components_image_alt_working_people: 'components_image_alt_working_people',
  components_image_alt_couple_hugging: 'components_image_alt_couple_hugging',
  components_image_alt_girl_in_a_boat: 'components_image_alt_girl_in_a_boat',
  components_image_alt_calculator: 'components_image_alt_calculator',
  components_image_alt_documents: 'components_image_alt_documents',
  components_image_alt_office_chat: 'components_image_alt_office_chat',
  components_image_alt_fixed_interest: 'components_image_alt_fixed_interest',
  components_image_alt_watering_plant: 'components_image_alt_watering_plant',
  components_customer_account_cell_avatar_label:
    'components_customer_account_cell_avatar_label',
  components_confirm_action_box_cancel_button_text:
    'components_confirm_action_box_cancel_button_text',
  components_amount_input_field_label: 'components_amount_input_field_label',
  components_cid_input_field_label: 'components_cid_input_field_label',
  components_message_input_field_label: 'components_message_input_field_label',
  components_message_input_field_placeholder:
    'components_message_input_field_placeholder',
  components_amount_input_field_min_amount:
    'components_amount_input_field_min_amount',
  components_breadcrumb_item_payments: 'components_breadcrumb_item_payments',
  components_checkboxlist_aria_label: 'components_checkboxlist_aria_label',
  components_amount_range_picker_min_input_label:
    'components_amount_range_picker_min_input_label',
  components_amount_range_picker_max_input_label:
    'components_amount_range_picker_max_input_label',
  components_amount_range_picker_max_input_placeholder:
    'components_amount_range_picker_max_input_placeholder',
  components_amount_range_picker_min_input_placeholder:
    'components_amount_range_picker_min_input_placeholder',
  components_date_range_picker_label: 'components_date_range_picker_label',
  components_date_range_picker_last_six_months_button_label:
    'components_date_range_picker_last_six_months_button_label',
  components_date_range_picker_last_this_year_button_label:
    'components_date_range_picker_last_this_year_button_label',
  components_date_range_picker_last_last_year_button_label:
    'components_date_range_picker_last_last_year_button_label',
  components_confirm_action_box_confirm_button_text:
    'components_confirm_action_box_confirm_button_text',
  components_filter_drawer_back_button_label:
    'components_filter_drawer_back_button_label',
  components_filter_drawer_title: 'components_filter_drawer_title',
  components_filter_drawer_reset_button_label:
    'components_filter_drawer_reset_button_label',
  components_transaction_details_sender:
    'components_transaction_details_sender',
  components_transaction_details_account_number:
    'components_transaction_details_account_number',
  components_transaction_details_amount:
    'components_transaction_details_amount',
  components_transaction_details_message:
    'components_transaction_details_message',
  components_transaction_details_date: 'components_transaction_details_date',
  components_transaction_details_to_text:
    'components_transaction_details_to_text',
  components_transaction_details_type_text:
    'components_transaction_details_type_text',
  components_transaction_details_booked:
    'components_transaction_details_booked',
  components_transaction_details_id: 'components_transaction_details_id',
  components_transaction_details_from: 'components_transaction_details_from',
  components_transaction_details_receiver:
    'components_transaction_details_receiver',
  components_transaction_details_type_einvoice:
    'components_transaction_details_type_einvoice',
  components_transaction_details_type_incoming:
    'components_transaction_details_type_incoming',
  components_transaction_details_type_vipps_in:
    'components_transaction_details_type_vipps_in',
  components_transaction_details_type_transfer:
    'components_transaction_details_type_transfer',
  components_transaction_details_type_outgoing:
    'components_transaction_details_type_outgoing',
  components_transaction_details_type_internationial:
    'components_transaction_details_type_internationial',
  components_transaction_details_type_pension:
    'components_transaction_details_type_pension',
  components_transaction_details_type_salary:
    'components_transaction_details_type_salary',
  components_transaction_details_type_loan:
    'components_transaction_details_type_loan',
  components_transaction_details_type_self_service:
    'components_transaction_details_type_self_service',
  components_transaction_details_type_atm:
    'components_transaction_details_type_atm',
  components_transaction_details_type_credit_card:
    'components_transaction_details_type_credit_card',
  components_transaction_details_type_visa_card:
    'components_transaction_details_type_visa_card',
  components_transaction_details_type_morsom_sparing:
    'components_transaction_details_type_morsom_sparing',
  components_transaction_details_type_debit_card:
    'components_transaction_details_type_debit_card',
  components_transaction_details_hide_transaction_cell_title:
    'components_transaction_details_hide_transaction_cell_title',
  components_transaction_details_hide_transaction_cell_description:
    'components_transaction_details_hide_transaction_cell_description',
  components_transaction_details_spendings_category_content:
    'components_transaction_details_spendings_category_content',
  components_transaction_details_type_business_payment:
    'components_transaction_details_type_business_payment',
  components_transaction_details_type_vipps_out:
    'components_transaction_details_type_vipps_out',
  components_form_summary_title_message:
    'components_form_summary_title_message',
};

Object.freeze(translationKeys);

export default translationKeys;
